import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '2032586933980278';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
/**
 * Injects the official Meta (Facebook) Pixel and fires a PageView.
 * Pixel ID: 2032586933980278
 *
 * Written defensively: any failure here is swallowed so it can never
 * blank out the page.
 */
export const MetaPixel = () => {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    try {
      if (!window.fbq) {
        const fbq: any = function (...args: unknown[]) {
          fbq.callMethod ? fbq.callMethod.apply(fbq, args) : fbq.queue.push(args);
        };
        window.fbq = fbq;
        if (!window._fbq) window._fbq = fbq;
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        fbq.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
      }
      window.fbq('init', PIXEL_ID);
      window.fbq('track', 'PageView');
    } catch (err) {
      // Never let analytics break the page
      console.error('Meta Pixel init failed:', err);
    }
  }, []);
  return null;
};
/** Helper to track custom Meta Pixel events from anywhere (e.g. CTA clicks). */
export const trackPixelEvent = (event: string, params?: Record<string, unknown>) => {
  try {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', event, params);
    }
  } catch {
    /* no-op */
  }
};